// TODO: add type for the Record values

import type { DottedPath } from './typeUtils';

// if this function is generalized even more why wouldn't we just use the jsonSetByPath function?
export const mutateObject = <TSchema extends Record<string, unknown>>(
    object: TSchema,
    mutation?: Partial<Record<DottedPath<TSchema>, unknown>> | Record<string, unknown>,
) => {
    const objectCopy = structuredClone(object);
    if (!mutation) return objectCopy;
    const clonedMutation = structuredClone(mutation);
    Object.entries(clonedMutation).forEach(([key, value]) => {
        const parts = key.split('.');
        const last = parts.pop() as string;
        const target = parts.reduce<any>((acc, part) => {
            if (!acc[part]) acc[part] = {};
            return acc[part];
        }, objectCopy);
        target[last] = value;
    });
    return objectCopy;
};
